
import { useTenantSlug } from '~/features/tenant/helpers';
import { TenantService } from '~/services/api/tenant/endpoints';
import { useIntakeChannel } from '~/slices/intakeChannelSlice';

export const usePriorityOptions = () => {
    const slug = useTenantSlug();
    const selectedChannel = useIntakeChannel().intakeChannelData.selectedChannel;

    const query = TenantService.endpoints.intakeChannelProgramDetails.useQuery({ slug, intakeChannelId: selectedChannel ?? 0 }, { skip: !selectedChannel || !slug });

    const priorityOptions = query.data?.report_configuration?.choices.priority_choices ?? [
        {
            'label': 'Low',
            'order': 1,
            'value': 0,
        },
        {
            'label': 'Medium',
            'order': 2,
            'value': 1,
        },
        {
            'label': 'High',
            'order': 3,
            'value': 2,
        },
        {
            'label': 'Critical',
            'order': 4,
            'value': 3,
        },
    ];

    return { priorityOptions };
};